export default __webpack_public_path__ + "static/media/Project07.6039af72.jpg";